const numeral = require('numeral');

numeral.register('locale', 'vi');
export default function regis(amount: number){
    return numeral(amount).format() + " lượt đăng ký";
}